import RouteConfig from './config/RouteConfig';
import QuestionSets from 'text!app-question-sets';
import HOConfirmation from 'edge/quoteandbind/ho/directives/HOConfirmation';
import HOUpgrade from 'edge/quoteandbind/ho/directives/HOUpgrade';
import HOSelectWithOther from 'edge/quoteandbind/ho/directives/HOSelectWithOther';
import HORoofTypeSelect from 'edge/quoteandbind/ho/directives/HORoofTypeSelect';
import HOTypelistRadios from 'edge/quoteandbind/ho/directives/HOTypelistRadios';
import HOQuoteOffering from 'edge/quoteandbind/ho/directives/HOQuoteOffering';

import defaultAdditionalCoverages from 'edge/quoteandbind/ho/directives/HoOfferingSelection/defaultQuoteView/defaultAdditionalCoverages/defaultAdditionalCoverages';
import defaultBaseCoverages from 'edge/quoteandbind/ho/directives/HoOfferingSelection/defaultQuoteView/defaultBaseCoverages/defaultBaseCoverages';

import mobileCoverages from 'edge/quoteandbind/ho/directives/HoOfferingSelection/mobileQuoteView/mobileCoverages/mobileCoverages';

import 'edge/quoteandbind/common/app';
import 'gw-portals-exp-lang-angular';
import 'angularRouter';

var questionSets = JSON.parse(QuestionSets);

export default angular.module('edge.quoteandbind.ho.app', ['edge.quoteandbind.common.app', 'edge.platform.el']).constant('HOConstants', {
    POLICY_TYPE_ID: 'HO3'
}).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).config(['QuestionSetServiceProvider', function (QuestionSetServiceProvider) {
    QuestionSetServiceProvider.addQuestionSets(questionSets);
}]).filter('orderObjectBy', function () {
    return function (items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function (item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            /*eslint-disable */
            return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
            /*eslint-enable */
        });
        if (reverse) {
            filtered.reverse();
        }
        return filtered;
    };
}).directive('gwQnbHoConfirmation', HOConfirmation).directive('gwQnbHoUpgrade', HOUpgrade).directive('gwQnbHoSelectWithOther', HOSelectWithOther).directive('gwQnbHoRoofTypeSelect', HORoofTypeSelect).directive('gwQnbHoTypelistRadios', HOTypelistRadios).directive('gwQnbHoQuoteOffering', HOQuoteOffering).component('gwQnbDefaultHoAdditionalCoverages', defaultAdditionalCoverages).component('gwQnbDefaultHoBaseCoverages', defaultBaseCoverages).component('gwQnbHoMobileCoverages', mobileCoverages);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=ho!./common/js/src/edge/quoteandbind/ho/app.js
// module id = 195
// module chunks = 0